import React from "react";
import { Col, Row } from "reactstrap";
import Widgets1 from "../../Common/CommonWidgets/Widgets1";

const WidgetsWrapper = ({ data }) => {
  return (
    <>
      <Col xxl="auto" xl="3" sm="6" className="box-col-6">
        <Row>
          {data.slice(1, 3).map((item, index) => (
            <Col xl="12" key={index}>
              <Widgets1 data={item} />
            </Col>
          ))}
        </Row>
      </Col>

      <Col xxl="auto" xl="3" sm="6" className="box-col-6">
        <Row>
          {data.slice(3, 5).map((item, index) => (
            <Col xl="12" key={index}>
              <Widgets1 data={item} />
            </Col>
          ))}
        </Row>
      </Col>

      <Col xxl="auto" xl="12" sm="6" className="box-col-6">
        <Row>
          {data.slice(0, 1).map((item, index) => (
            <Col xxl="12" xl="12" className="box-col-12" key={index}>
              <Widgets1 data={item} />
            </Col>
          ))}
        </Row>
      </Col>
    </>
  );
};

export default WidgetsWrapper;
